export const USER_FORM = {
    'USER.DETAILS': 'Date de identificare ale utilizatorului',
    'USER.FIRST_NAME': 'Prenume',
    'USER.LAST_NAME': 'Nume',
    'USER.EMAIL': 'Adresă de e-mail',
    'USER.ASSOCIATIONS': 'Asocieri ale utilizatorului',
    'USER.ASSOCIATION_DETAILS': 'Detalii asociere {{index}}',
    'USER.ASSOCIATION.CLIENT': 'Clientul',
    'USER.ASSOCIATION.CLIENT_PLACEHOLDER': 'Selectați clientul',
    'USER.ASSOCIATION.COMPANY': 'Compania',
    'USER.ASSOCIATION.COMPANY_PLACEHOLDER': 'Selectați compania',
    'USER.ASSOCIATION.AVAILABLE_ROLES': 'Roluri disponibile',
    'USER.BUTTON.ADD_ASSOCIATION': 'Adaugă asociere nouă',
    'USER.MESSAGE.AVAILABLE_USER': '{{availableUsersNo}} utilizator disponibil',
    'USER.MESSAGE.AVAILABLE_USERS': '{{availableUsersNo}} utilizatori disponibili',
    'USER.MESSAGE.ROLES_WILL_BE_GENERATED_AFTER_CHOOSING_CLIENT_AND_COMPANY': 'Lista de roluri se va genera în urma selecției clientului și a companiei',
    'USER.MESSAGE.NO_ROLES_AVAILABLE_FOR_COMPANY': 'Această companie nu are o structură de roluri disponibilă. Trebuie selectată o structură de roluri din cadrul secțiunii Companii',
    'USER.VALIDATION.INSERT_EMAIL': 'Introduceţi adresa de e-mail a utilizatorului',
    'USER.VALIDATION.EMAIL_IS_ALREADY_ASSOCIATED_TO_CLIENT': 'Adresa de e-mail introdusă este utilizată de un alt utilizator',
    'USER.VALIDATION.INSERT_LAST_NAME': 'Introduceţi numele utilizatorului',
    'USER.VALIDATION.LAST_NAME_IN_INTERVAL': 'Numele utilizatorului trebuie să fie de minim 3, maxim 100 caractere',
    'USER.VALIDATION.INSERT_FIRST_NAME': 'Introduceţi prenumele utilizatorului',
    'USER.VALIDATION.FIRST_NAME_IN_INTERVAL': 'Prenumele utilizatorului trebuie să fie de minim 3, maxim 100 caractere',
    'USER.VALIDATION.SELECT_CLIENT': 'Selectaţi un client',
    'USER.VALIDATION.SELECT_COMPANY': 'Selectaţi o companie',
    'USER.VALIDATION.SELECT_ROLE': 'Selectaţi un rol',
    'USER.VALIDATION.ROLE_ALREADY_SELECTED_FOR_COMPANY': 'Utilizatorul are deja un rol asociat acestei companii'
};
